import React from 'react';

export const IconComponent = (img: string) => {
    return <img src={img} alt="" />;
};
